module.exports = __webpack_public_path__ + "assets/ziyuan_8.c3489946.svg";